import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MustMatch } from 'src/app/data-service/must-match.validator';
import { takeUntil } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { LoaderService } from '../shared.service';

@Component({
  selector: 'app-add-admin-dg-users',
  templateUrl: './add-admin-dg-users.component.html',
  styleUrls: ['./add-admin-dg-users.component.scss']
})
export class AddAdminDgUsersComponent implements OnInit {
  private ResponseVerifiedGetAllDgUser: Subject<any> = new Subject();
  isEditing: boolean = false;
  userId: any;
  addDgForm: FormGroup;
  dataObject: { search: string; limit: number; offset: number; };
  adminEpcUserList: any;
  pipe = new DatePipe('en-US');
  editUserObject: { id: any; };
  addenergy_meter: any;
  energy_meter = false;
  graph_interval: any;
  marked = false;
  wms = false;
  addWms: any;
  isdevice: number;
  graph_inv: any;
  time: any = [{ "id": "14" }, { "id": "13" }, { "id": "12" }, { "id": "11" }, { "id": "10" }, { "id": "9" }, { "id": "8" }, { "id": "7" }, { "id": "6" }, { "id": "5" }, { "id": "4" }, { "id": "3" }, { "id": "2" }, { "id": "1" }];

  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute,
     private dashbord: DashboardService, private toastr: ToastrService,  private loaderService: LoaderService) {
    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });
  }

  ngOnInit() {
    this.addDgForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.

      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      emails: this.fb.array([
        this.createEmailField()
      ]),
      password: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      sim_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      instd_capacity: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,3})?$")]],
      num_inverter: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      elec_rate: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      start_dt: ['', Validators.required],
      end_dt: ['', Validators.required],
      solar_panel: ['', [Validators.pattern("^[a-zA-Z0-9]+$")]],
      num_solar_panel: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      area_solar_panel: [null, [Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      eff_solar_panel: [null, [Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_v: [null, [Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      t_coeff_p: [null, [Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      epc_id: ['', [Validators.required]],
      confirmPassword: ['', Validators.required],
      wms: [''],
      energy_meter: [''],
      graph_interval: [''],
      // dg_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      //   dg_rating: ['',[Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
    }, {
      validator: MustMatch('password', 'confirmPassword')
    }
    );
    this.getAllDGEpcUser();
    if (this.isEditing == true) {
      this.getInfoByUserId()
    }
  }
  get f() { return this.addDgForm.controls; }
  // email form array
  get emails(): FormArray {
    return this.addDgForm.get('emails') as FormArray;
  }

  createEmailField(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")]]
    });
  }

  // add email
  addEmail(): void {
    this.emails.push(this.createEmailField());
  }

  // remove email
  removeEmail(index: number): void {
    this.emails.removeAt(index);
  }

  createEmailControls(emailArray) {
    for (let i = 1; i < emailArray.length; i++) {
      this.addEmail();
    }
  }

  onEpcChange(epc) {
  }
  // get alladmin epc user list
  getAllDGEpcUser() {
    this.dataObject = {
      search: '',
      limit: 0,
      offset: 0
    }
    this.dashbord.getAllDGEpcUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllDgUser))
      .subscribe(
        async data => {
          if (data.status) {
            this.adminEpcUserList = data.resultObject.sort((a: { name: string; }, b: { name: any; }) => a.name.localeCompare(b.name));

            // this.adminEpcUserList = data.resultObject;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  add_dg() {
    if (this.addDgForm.value.graph_interval == "") { this.graph_inv = "15"; }
    else {
      this.graph_inv = this.addDgForm.value.graph_interval;
    }
    if (this.addDgForm.value.energy_meter == true || this.addDgForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addDgForm.value.energy_meter == false || this.addDgForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    }
    if (this.addDgForm.value.wms == true || this.addDgForm.value.wms == 'true') {
      this.addWms = 1;
    } else if (this.addDgForm.value.wms == false || this.addDgForm.value.wms == 'false') {
      this.addWms = 0;
    }
    var dgInfo =
    {
      "login_id": this.addDgForm.controls['login_id'].value,
      "name": this.addDgForm.controls['name'].value,
      "email": this.loaderService.convertEmailsInString(this.addDgForm.controls['emails'].value),
      "password": this.addDgForm.controls['password'].value,
      "mobile_no": this.addDgForm.controls['mobile_no'].value,
      "address": this.addDgForm.controls['address'].value,
      "sim_no": this.addDgForm.controls['sim_no'].value,
      "instd_capacity": this.addDgForm.controls['instd_capacity'].value,
      "num_inverter": this.addDgForm.controls['num_inverter'].value,
      "elec_rate": this.addDgForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addDgForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addDgForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addDgForm.controls['solar_panel'].value,
      "num_solar_panel": this.addDgForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addDgForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addDgForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addDgForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addDgForm.controls['t_coeff_p'].value,
      "epc_id": this.addDgForm.controls['epc_id'].value,
      "is_emeter": this.addenergy_meter,
      "is_wms": this.addWms,
      // "dg_name": this.addDgForm.controls['dg_name'].value,
      //  "dg_rating": this.addDgForm.controls['dg_rating'].value,
      "graph_interval": this.graph_inv
    }
    this.dashbord.AdminaddDG(dgInfo)
      .pipe(takeUntil(this.ResponseVerifiedGetAllDgUser))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/admin-user-registration/admin-dg-users']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }
  getInfoByUserId() {
    this.editUserObject = {
      id: this.userId
    };
    this.dashbord.getAdminInfoByDgUserId(this.editUserObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllDgUser))
      .subscribe(
        async data => {
          if (data.status) {
            this.dataObject = data.resultObject;
            this.isdevice = this.dataObject[0].isdevice;
            
            var editEnergyMeter = data.resultObject[0].is_emeter;
            var editWms = data.resultObject[0].is_wms;


            if (editEnergyMeter == 0) {
              this.marked = false;
              this.toggleVisibility(this.marked);
            } else if (editEnergyMeter == 1) {
              this.marked = true;
              this.toggleVisibility(this.marked);
            }
            if (editWms == 0) {
              this.marked = false;
              this.toggleVisibilityDg(this.marked);
            } else if (editWms == 1) {
              this.marked = true;
              this.toggleVisibilityDg(this.marked);
            }
            // if(editGraphInterval=="")
            // { editGraphInterval ="15";}
            if (this.isdevice) {
              this.addDgForm.get('epc_id').disable();
            }

            const emails = this.loaderService.convertSrtingIntoArrayOfObj(this.dataObject[0].email);
            this.createEmailControls(emails);
            // set value on the from
            this.addDgForm.get('login_id').setValue(data.resultObject[0].login_id);
            this.addDgForm.get('name').setValue(this.dataObject[0].name);
            this.addDgForm.get('emails').setValue(emails);
            this.addDgForm.get('mobile_no').setValue(this.dataObject[0].mobile_no);
            this.addDgForm.get('address').setValue(this.dataObject[0].address);
            this.addDgForm.get('sim_no').setValue(this.dataObject[0].sim_no);
            this.addDgForm.get('instd_capacity').setValue(this.dataObject[0].instd_capacity);
            this.addDgForm.get('num_inverter').setValue(this.dataObject[0].num_inverter);
            this.addDgForm.get('elec_rate').setValue(this.dataObject[0].elec_rate);
            this.addDgForm.get('start_dt').setValue(this.dataObject[0].start_dt);
            this.addDgForm.get('end_dt').setValue(this.dataObject[0].end_dt);
            this.addDgForm.get('solar_panel').setValue(this.dataObject[0].solar_panel);
            this.addDgForm.get('num_solar_panel').setValue(this.dataObject[0].num_solar_panel);
            this.addDgForm.get('area_solar_panel').setValue(this.dataObject[0].area_solar_panel);
            this.addDgForm.get('eff_solar_panel').setValue(this.dataObject[0].eff_solar_panel);
            this.addDgForm.get('t_coeff_v').setValue(this.dataObject[0].t_coeff_v);
            this.addDgForm.get('t_coeff_p').setValue(this.dataObject[0].t_coeff_p);
            this.addDgForm.get('epc_id').setValue(this.dataObject[0].epc_id);
            this.addDgForm.get('graph_interval').setValue(data.resultObject[0].graph_interval);
            //  this.addDgForm.get('dg_name').setValue(this.dataObject[0].dg_name);
            //  this.addDgForm.get('dg_rating').setValue(this.dataObject[0].dg_rating);
            this.addDgForm.get('password').setValue("password");
            this.addDgForm.get('confirmPassword').setValue("password");
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // update wms user
  update_dg() {
    if (this.addDgForm.value.wms == true || this.addDgForm.value.wms == 'true') {
      this.addWms = 1;
    } else if (this.addDgForm.value.wms == false || this.addDgForm.value.wms == 'false') {
      this.addWms = 0;
    }
    if (this.addDgForm.value.energy_meter == true || this.addDgForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addDgForm.value.energy_meter == false || this.addDgForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    }
    var dgInfo =
    {
      "id": this.userId,
      "login_id": this.addDgForm.controls['login_id'].value,
      "name": this.addDgForm.controls['name'].value,
      "email": this.loaderService.convertEmailsInString(this.addDgForm.controls['emails'].value),
      "mobile_no": this.addDgForm.controls['mobile_no'].value,
      "address": this.addDgForm.controls['address'].value,
      "sim_no": this.addDgForm.controls['sim_no'].value,
      "instd_capacity": this.addDgForm.controls['instd_capacity'].value,
      "num_inverter": this.addDgForm.controls['num_inverter'].value,
      "elec_rate": this.addDgForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addDgForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addDgForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addDgForm.controls['solar_panel'].value,
      "num_solar_panel": this.addDgForm.controls['num_solar_panel'].value,
      "area_solar_panel": this.addDgForm.controls['area_solar_panel'].value,
      "eff_solar_panel": this.addDgForm.controls['eff_solar_panel'].value,
      "t_coeff_v": this.addDgForm.controls['t_coeff_v'].value,
      "t_coeff_p": this.addDgForm.controls['t_coeff_p'].value,
      "epc_id": this.addDgForm.controls['epc_id'].value,
      // "dg_name": this.addDgForm.controls['dg_name'].value,
      // "dg_rating": this.addDgForm.controls['dg_rating'].value,
      "is_emeter": this.addenergy_meter,
      "is_wms": this.addWms,
      "graph_interval": this.addDgForm.controls['graph_interval'].value,
    }
    this.dashbord.adminUpdateDgUser(dgInfo).pipe(takeUntil(this.ResponseVerifiedGetAllDgUser))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/admin-user-registration/admin-dg-users']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }
  toggleVisibility(e) {
    if (e === false) {
      this.marked = false;
      this.energy_meter = false;
    } else if (e == true) {
      this.marked = true;
      this.energy_meter = true;
    }
  }
  toggleVisibilityDg(e) {
    if (e === false) {
      this.marked = false;
      this.wms = false;
    } else if (e == true) {
      this.marked = true;
      this.wms = true;
    }
  }
  changeTime(e) {
  }
  ngOnDestroy() {
    this.ResponseVerifiedGetAllDgUser.next();
    this.ResponseVerifiedGetAllDgUser.complete();
  }
}
